module.exports = __webpack_public_path__ + "media/images/illustration-cd20fb48.png";